import { Box } from "@mui/material";
import React from "react";
import ReviewAttendance from "./ReviewAttendance";
import PageTitle from "../../components/Page Component/PageTitle";
import ErrorBoundary from "../../components/Error/ErrorBoundary";
import Footer from "../../components/Page Component/Footer";
import Navbar from "../../components/Page Component/Navbar";

const ViewAttendaceRecords = () => {
  return (
    <ErrorBoundary>
      <Box sx={{ width: "100%", mt: 12, mb: 10 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 16px",
          }}
        >
          <Box sx={{ width: "100%" }}>
            {/* Page Header */}
            <Box sx={{ mb: 3 }}>
              <PageTitle>Review Attendance</PageTitle>
            </Box>

            {/* Main Content */}
            <ReviewAttendance />
          </Box>
        </Box>
      </Box>
    </ErrorBoundary>
  );
};

export default ViewAttendaceRecords;
